import {SortableTable} from "./sortable-table";
import {ascending, descending} from "d3-array";
import {L} from "../lt-ng/landcare-toolkit";
import LayerService = L.util.LayerService;

interface IReportTableScope extends ng.IScope {
    caret: (column) => { hidden: boolean; up: boolean };
    tableRows: any[];
    sortedTableRows: any[];
    reportLayerService: LayerService;
    reportData: any;
    unclassifiedLandArea: number;
    waterArea: number;
    showAll: boolean;
}

export class ReportTable extends SortableTable {
    scope = {
        tableRows: '=',
        reportLayerService: '=',
        reportData: '='
    };
    replace: true;
    template = `<div class="table-responsive w-100">
    <table class="table table-condensed table-striped w-100" ng-if="sortedTableRows.length">
        <thead>
            <tr>
                <th role="button" ng-click="sortBy('classNo')">
                    Class
                    <span class="caret ng-cloak" ng-class="caret('classNo')"></span>
                </th>
                <th role="button" ng-click="sortBy('description')">
                    Description
                    <span class="caret ng-cloak" ng-class="caret('description')"></span>
                </th>
                <th role="button" ng-click="sortBy('area')"> 
                    Area
                    <span class="caret ng-cloak" ng-class="caret('area')"></span>
                </th>
            </tr>
        </thead>
        <tbody>
            <tr ng-repeat="row in sortedTableRows">
                 <td class="text-center">
                    <img ng-attr-alt="{{row.description}}" ng-if="(row.classNo|iconForClass:reportLayerService).length" ng-src="{{row.classNo|iconForClass:reportLayerService}}"/>
                </td>                
                <td>
                    {{row.description}}
                </td>
                <td class="text-right">
                    {{ row.area | m2ToHectares }}ha                
                </td>
            </tr>
            <tr ng-if="tableRows && tableRows.length">
                    <td></td><td>Unclassified Land</td><td class="text-right">{{ unclassifiedLandArea | m2ToHectares }}ha</td>
            </tr>
            <tr ng-if="tableRows && tableRows.length && waterArea !== undefined">
                <td></td><td>Water</td><td class="text-right">{{ waterArea | m2ToHectares }}ha</td>
            </tr>
        </tbody>
    </table>
</div>`;
    link = function($scope: IReportTableScope, elements: any, attrs: any) {
        let sortBy = 'classNo';
        let sortDirection = ascending;

        $scope.showAll = false;

        const update = () => {
            const rows = $scope.tableRows || [];
            $scope.sortedTableRows = [...rows]
                .sort((a, b) => sortDirection(a[sortBy], b[sortBy]));
            if (!$scope.showAll && rows.length > 10) {
                $scope.sortedTableRows = $scope.sortedTableRows.slice(0, 8);
            }
            const response: any = $scope.reportData && $scope.reportData.response;

            $scope.unclassifiedLandArea = response ? response.unclassified : 0;
            const waterArea = response ? response.totalArea - response.totalSmapArea - response.unclassified : 0;
            $scope.waterArea = waterArea >= 0 ? waterArea : undefined;
        };

        $scope.caret = (column) => {
            return {
                'hidden': sortBy !== column,
                'up': sortDirection === ascending
            }
        }

        $scope['sortBy'] = (column: string) => {
            if (sortBy === column) {
                sortDirection = sortDirection === ascending ? descending : ascending;
            }
            sortBy = column;
            $scope.showAll = true;
            update();
        };

        $scope.$watch('tableRows', update);
        update();

        $scope.$watch('reportLayerService', (layerService) => console.log(layerService));
    };
    static factory() {
        const directive = () => new ReportTable();
        directive.$inject = [];
        return directive;
    }
}